import http from "./httpService";

const apiEndpoint = "/Counties";


export function getCounties() {
  return http.get(apiEndpoint);
}
